import React from "react";
import { Alert, Card, Col, Container, Row } from "react-bootstrap";
import '../../paths/home/home.css';
import { Link } from "react-router-dom";


export default function Demo() {

    const dashboardItems = [
        {
            text: 'Cards',
            description: 'Example card front, back, display pieces and contexts',
            location: '/demo/cards',
        },
        {
            text: 'Player Data',
            description: 'Example Player Data cards',
            location: '/demo/playerData',
        },
    ];

    return (
        <Container className='py-5 d-flex flex-column flex-grow-1 justify-content-start align-items-center bg-transparent'>
            {dashboardItems.length === 0 && (
                <Alert variant='info' className='mt-3'>
                    You don't currently have access to any features. Please contact support if this is
                    unexpected.
                </Alert>
            )}

            <Row className='g-4 justify-content-center' style={{ width: '100%' }}>
                {dashboardItems.map((item) => (
                    <Col key={item.text} xs={12} sm={6} md={4} lg={3} className='d-flex'>
                        <Card className='h-100 shadow-sm transition-hover-lift w-100'>
                            <Card.Body className='d-flex flex-column'>
                                <div className='d-flex align-items-center mb-3'>
                                    <h3 className='mb-0'>{item.text}</h3>
                                </div>
                                <Card.Text className='text-muted flex-grow-1'>{item.description}</Card.Text>
                                <Link to={item.location} className='btn btn-outline-primary mt-auto'>
                                    Go
                                </Link>
                            </Card.Body>
                        </Card>
                    </Col>
                ))}
            </Row>
        </Container>
    );
}